import React from 'react';
import PropTypes from 'prop-types';
import { Scale } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AICompareButton = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <button
      type='button'
      className='ai-compare-button ai-compare-button--disabled'
      onClick={e => e.preventDefault()}
      disabled={true}
    >
      <Scale size={18} aria-hidden='true' />
      <span>{t('ai_compare.compare_button_label')}</span>
    </button>
  );
};

AICompareButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

AICompareButton.defaultProps = {
  disabled: false,
};

export default AICompareButton;
